import type { NodeSearchResult } from "@stoplight/elements-dev-portal";
import {
  Search as ElementsSearch,
  useGetNodes,
  useGetWorkspace,
} from "@stoplight/elements-dev-portal";
import * as React from "react";
import styled from "styled-components/macro";
import SearchIcon from "@material-ui/icons/Search";
import { useTranslation } from "react-i18next";

const SearchContainer = styled.div`
  display: flex;
  align-items: center;
`;
const IconContainer = styled.div`
  display: flex;
  padding: 7px 15px;
  cursor: pointer;
  background: linear-gradient(90deg, #84fab0 0%, #8feafe 100%);
`;

export type SearchProps = {
  projectIds: string[];
};

export const Search = ({ projectIds }: SearchProps) => {
  const [search, setSearch] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const { t } = useTranslation();
  const { data: workspace } = useGetWorkspace({
    projectIds,
  });

  const { data } = useGetNodes({
    search,
    projectIds,
  });

  const handleClose = () => {
    setOpen(false);
    setSearch("");
  };

  const handleClick = (data: NodeSearchResult) => {
    window.location.href = `${window.location.origin}/documentation#/${data.slug}`;
    handleClose();
  };

  return (
    <>
      <SearchContainer>
        <IconContainer
          onClick={() => {
            setOpen(true);
          }}
        >
          <SearchIcon style={{ color: "black" }} fontSize="default" />
          <div style={{ color: "black" }}>
            {t("propertyPage_Controllers_SearchDoc")}
          </div>
        </IconContainer>

        <button type="submit" style={{ display: "none" }}></button>
      </SearchContainer>
      <ElementsSearch
        search={search}
        onSearch={setSearch}
        onClick={handleClick}
        onClose={handleClose}
        isOpen={open}
        searchResults={data}
      />
    </>
  );
};
